// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"36":"fe70078c","141":"ccb81b52","289":"d9f2114b","533":"4d31a616","682":"ccb81b52","909":"9a1bb76c"}[chunkId] + ".chunk.css";
};